module.exports = "<ul class=holding-dashboard-sidebar__list> <holding-flow-sidebar-progress-step label=\"{{::step.label}}\" state=\"{{::step.state}}\" status=\"{{stepState($index)}}\" ng-repeat=\"step in steps track by step.key\"> </holding-flow-sidebar-progress-step> </ul> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/flow/directives/flow-sidebar-progress-steps/flow-sidebar-progress-steps.html
// module id = 533
// module chunks = 0